import React, { useEffect, useState, useRef } from "react";
import style from "./style.module.css";
import useFormat from "../../hooks/utils/useFormat";

const ChartsBar = props => {
  const { data, title, type, reports, format_value = "", ...others } = props;
  const { formatReal } = useFormat();

  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (reports) {
      let totalVar = 0;
      reports.forEach(__report => {
        totalVar += __report.value || 0;
      });
      setTotal(totalVar || 0);
    }
  }, [reports]);

  // Temp Generator
  const [hover, setHover] = useState();

  return (
    <>
      <div className={`${style.ChartsBar} mt-4`}>
        <div className={style.header}>
          {!!title ? <h4>{title}</h4> : <span></span>}
          <span>{`Total: ${format_value === "real" ? formatReal(total) : total?.toFixed(2)} ${type}`}</span>
        </div>
        <div className={style.reportChart}>
          <div>
            <div>
              <div className={style.bars}>
                {reports.map(
                  (e, index) =>
                    !!e.value && (
                      <div
                        style={{ flexGrow: e.value, background: e?.color || `var(--color-cycle-${index + 1})` }}
                        onMouseOver={() => setHover(index)}
                        onMouseLeave={() => setHover(-1)}
                        className={`${style.singleBar} ${hover === index ? "hover" : ""}`}
                      >
                        <div className={style.toolTip}>
                          <div className={style.toolTipContent}>
                            <p>
                              <span
                                style={{ background: e?.color || `var(--color-cycle-${index + 1})` }}
                                className={style.circle}
                              ></span>
                            </p>
                            <p>
                              <span className={style.labelTxt}>{e.label}</span>
                            </p>
                            <p>
                              <span className={style.smallLabel}>
                                {format_value === "real" ? formatReal(e.value) : e.value.toFixed(2)} (
                                {(e.value ? (e.value / total) * 100 : 0).toFixed(2)}%)
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ),
                )}
              </div>
              <div className={style.labels}>
                {reports?.map((__report, __report_i) => {
                  const _value = Number(__report?.value || 0);
                  const _value_formated =
                    format_value === "real" ? formatReal(_value) : _value % 1 !== 0 ? _value.toFixed(2) : _value;
                  const _value_percent = `${(_value ? (_value / total) * 100 : 0).toFixed(2)}%`;

                  return (
                    <div
                      className={`${style.label} ${hover === __report_i ? "hover" : ""}`}
                      onMouseOver={() => setHover(__report_i)}
                      onMouseLeave={() => setHover(-1)}
                      style={{ opacity: __report.value > 0 ? "1" : ".333" }}
                    >
                      <span
                        style={{ background: __report?.color || `var(--color-cycle-${__report_i + 1})` }}
                        className={style.circle}
                      ></span>
                      <span className={style.labelTxt}>{__report.label}</span>
                      <span className={style.smallLabel}>
                        {_value_formated} ({_value_percent})
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ChartsBar };
